export default __webpack_public_path__ + "static/media/reload_update.0de1b872.svg";